import React from 'react';
import styled from 'styled-components';

const HomeButtonComp = ({ className, title, img, link }) => {
	return (
		<>
			<a href={link} style={{ textDecoration: 'none' }}>
				<button className={className}>
					<img src={img}></img>
					<h3>{title}</h3>
				</button>
			</a>
		</>
	);
};

const HomeButton = styled(HomeButtonComp)`
	display: flex;
	flex-direction: column;
	justify-content: end;
	width: 22vw;
	height: fit-content;
	padding: 0;
	border-radius: 1rem;
	transition: all 0.3s ease-in-out;

	& h3 {
		margin: 0 auto;
		background: darkblue;
		color: #fff;
		width: 100%;
		padding: 10px;
		border-bottom-left-radius: 0.8rem;
		border-bottom-right-radius: 0.8rem;
	}

	& img {
		width: 100%;
		height: auto;
		border-top-left-radius: 1rem;
		border-top-right-radius: 1rem;
		margin: auto;
	}

	&:hover {
		transform: scale(1.01);
	}

	@media screen and (max-width: 480px) {
		width: 80vw;
		margin: 30px auto;
		height: 31vh;
	}
`;

export default HomeButton;
